export const optionColorSchemes = [
  'bg-blue-100 text-blue-700 border-blue-200',
  'bg-purple-100 text-purple-700 border-purple-200',
  'bg-green-100 text-green-700 border-green-200',
  'bg-orange-100 text-orange-700 border-orange-200',
  'bg-pink-100 text-pink-700 border-pink-200',
  'bg-indigo-100 text-indigo-700 border-indigo-200',
];

export const getOptionColorScheme = (index: number): string => {
  return optionColorSchemes[index % optionColorSchemes.length];
};

export interface LegacyItemOptions {
  size?: string;
  strength?: string;
}

export const formatLegacySize = (size: string): string => {
  return size === 'normal' ? 'Normal' : 'Büyük';
};

export const formatLegacyStrength = (strength: string): string => {
  if (strength === 'light') {
    return 'Açık';
  }
  if (strength === 'normal') {
    return 'Normal';
  }
  return 'Koyu';
};

export const calculateItemTotal = (quantity: number, price: number): string => {
  return (quantity * price).toFixed(2);
};

export const formatPricePerUnit = (price: number): string => {
  return `${price} ₺ / adet`;
};

export const itemCardClasses =
  'bg-white/90 backdrop-blur-sm p-5 rounded-xl border border-green-200 shadow-sm hover:shadow-md transition-all duration-200 hover:scale-105';
export const optionTagClasses = 'px-3 py-1 rounded-full text-xs font-medium border';
export const legacyOptionTagClasses = 'px-2 py-1 rounded-full text-xs font-medium border';
